
import SubscriptionSelectModal from '../obs/SubscriptionSelectModal'
import AppDropdown from '../AppDropdown'

export default {
  name: 'DownloadAlertButton',
  components: { AppDropdown, SubscriptionSelectModal },
  props: {
    alertId: {
      type: [String, Number],
      default: 0
    },
    buttonClass: {
      type: String,
      default: ''
    },
    language: {
      type: String,
      default: 'en'
    }
  },
  data () {
    return {
      canConsume: false,
      showSubscriptionPlans: false,
      alertSets: []
    }
  },
  computed: {
    selectableAlertSets () {
      const selectables = []

      for (const alertSet of this.alertSets) {
        selectables.push({
          key: alertSet.id,
          label: alertSet.title
        })
      }

      return selectables
    }
  },
  created () {
    this.fetchAlertSets()
  },
  methods: {
    fetchAlertSets () {
      this.$axios
        .get(`v1/users/${this.$store.getters['user/currentId']}/alert-config-sets/`)
        .then(({ data: { data } }) => {
          this.alertSets = data
        })
    },
    async download (alertSetId) {
      try {
        this.canConsume = await this.$store.dispatch('consume/consumeEntitlement', {
          id: this.alertId,
          type: 'alerts',
          confirmed: true,
          language: this.language
        })

        const sku = this.canConsume.data.sku
        const alertPackConfig = sku.locale_configs[0]

        if (!alertPackConfig) {
          return
        }

        this.$store.commit('SET_XHR_LOADING', true)
        const { data: userAlertConfig } = await this.$axios
          .get(`v1/users/${this.$store.getters['user/currentId']}/alert-config-sets/${alertSetId}/`)

        userAlertConfig.alert_id = sku.id
        userAlertConfig.alert_locale = alertPackConfig.locale

        // replace defaults
        for (const key of Object.keys(alertPackConfig.config.default)) {
          userAlertConfig.default[key] = alertPackConfig.config.default[key]
        }

        // TO:DO optimize this, i dont know why vue-i18n is so stupid
        // if (alertPackConfig.locale !== this.$i18n.locale) {
        //   const currentLocale = this.$i18n.locale;
        //   await this.$i18n.setLocale(alertPackConfig.locale);
        //   await this.$i18n.setLocale(currentLocale);
        // }
        // const defaultEvents = getDefaultEvents.bind(this)(alertConfig.locale);

        const packVariations = {}

        // build alert pack variations
        for (const packVariation of alertPackConfig.config.variations) {
          packVariations[packVariation.conditions.type] = packVariation
        }

        // replace alert pack variables
        for (const userVariation of userAlertConfig.variations) {
          if (!packVariations[userVariation.conditions.type]) {
            continue
          }

          for (const keyx of Object.keys(packVariations[userVariation.conditions.type].overrides)) {
            userVariation.overrides[keyx] = packVariations[userVariation.conditions.type].overrides[keyx]
          }
        }

        // save config
        await this.$axios
          .patch(`v1/users/${this.$store.getters['user/currentId']}/alert-config-sets/${alertSetId}/`, userAlertConfig)

        this.$store.commit('SET_XHR_LOADING', false)
        this.$toast.success(this.$t('obs.alerts.success').toString())
        this.$emit('close')
      } catch (error) {
        if (error.message === '409') {
          this.showSubscriptionPlans = true
        }

        this.$store.commit('SET_XHR_LOADING', false)
      }
    }
  }
}
